// Import of the module

import { Link } from "@heroui/link";
import i18n from "@/i18n";
import { ColumnDef } from "@tanstack/react-table";
import { parseDate } from "@/lib/utils";

// Type of the fields in the table

export type GroupUser = {
  id: string;
  client: string;
  name: string;
  tableau_username: string | null;
  created_at: string;
  updated_at: string;
};

// Definition of the columns

export const group_users_columns: ColumnDef<GroupUser>[] = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    accessorKey: "client",
    header: "Client",
  },
  {
    accessorKey: "name",
    header: "Name",
  },
  {
    accessorKey: "tableau_username",
    header: "Tableau Username",
    cell: ({ row }) => row.getValue("tableau_username") || "",
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => parseDate(row.getValue("created_at")),
  },
  {
    accessorKey: "updated_at",
    header: "Updated At",
    cell: ({ row }) => parseDate(row.getValue("updated_at")),
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Link
          href={`${window.location.pathname}/${row.getValue("id")}`}
          className="text-xs"
          underline="hover"
        >
          {i18n.t("actions.edit")}
        </Link>
      </div>
    ),
  },
];
